import { dealDamage, addModifier, healthRemove } from '../player.type';
import type { Die } from '../die.type';
import type { Player } from '../player.type';
import type { Technique } from '../techniques.type';
import { StatusEffect } from '../status-effects.type';
import { DieFace } from '../face.type';
import { SoundType } from '../../components/audio.svelte';

export const misc: Technique[] = [
  {
    ingredients: [DieFace.Cloak, DieFace.Cloak],
    title: 'Hide',
    text: 'Gain 1 Stealth.',
    tags: ['defence'],
    audio: SoundType.BuffAgility,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(source, StatusEffect.Stealth, 1);
    },
  },
  {
    ingredients: [DieFace.Cloak, DieFace.Cloak, DieFace.Cloak],
    title: 'Vanish',
    text: 'Gain 2 Stealth and 1 Dodge.',
    tags: ['defence'],
    audio: SoundType.BuffAgility,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(source, StatusEffect.Dodge, 1);
      addModifier(source, StatusEffect.Stealth, 2);
    },
  },
  {
    ingredients: [DieFace.Hoof, DieFace.Hoof],
    title: 'Buck',
    text: 'Apply 1 Stunned.',
    tags: ['debuff'],
    audio: SoundType.AttackBlunt,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(target, StatusEffect.Stunned, 1);
    },
  },
  {
    ingredients: [DieFace.Fist, DieFace.Poison],
    title: 'Throw Poison',
    text: 'Deal 1 Damage, Apply 1 Poisoned.',
    tags: ['damage', 'debuff'],
    audio: SoundType.AttackPierce,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      dealDamage({ value: 1, target, source, dice });
      addModifier(target, StatusEffect.Poison, 1);
    },
  },
  {
    ingredients: [DieFace.Poison, DieFace.Poison],
    title: 'Imbue Poison',
    text: 'Gain 2 Imbue (poisoned).',
    tags: ['buff'],
    audio: SoundType.None,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(source, StatusEffect.Imbue, 2, { imbue: StatusEffect.Poison });
    },
  },
  {
    ingredients: [DieFace.Eye, DieFace.Cloak],
    title: 'Stalk Pray',
    text: 'Gain 1 Stealth and 1 Accuracy.',
    tags: ['defence', 'buff'],
    audio: SoundType.None,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(source, StatusEffect.Stealth, 1);
      addModifier(source, StatusEffect.Accuracy, 1);
    },
  },
  {
    ingredients: [DieFace.Agility, DieFace.Cloak],
    title: 'Escape',
    text: 'Gain 1 Stealth and 1 Dodge.',
    tags: ['defence', 'buff'],
    audio: SoundType.None,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(source, StatusEffect.Stealth, 1);
      addModifier(source, StatusEffect.Dodge, 1);
    },
  },

  {
    ingredients: [DieFace.Wings],
    title: 'Flap',
    text: 'Gain 1 Dodge.',
    tags: ['defence'],
    audio: SoundType.None,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(source, StatusEffect.Dodge, 1);
    },
  },
  {
    ingredients: [DieFace.Wings, DieFace.Wings],
    title: 'Flip-Flap',
    text: 'Gain 3 dodge.',
    tags: ['defence'],
    audio: SoundType.None,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(source, StatusEffect.Dodge, 3);
    },
  } /* {
    ingredients: [DieFace.Wings, DieFace.Wings, DieFace.Wings],
    title: 'Fly',
    text: 'Gain 1 Immortal',
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      // addModifier(source, 'immortal', 1);
    }
  }, */,

  {
    ingredients: [DieFace.Web],
    title: 'Capture',
    text: 'Apply 1 Snared.',
    tags: ['debuff'],
    audio: SoundType.AttackWeb,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(target, StatusEffect.Snared, 1);
    },
  },
  {
    ingredients: [DieFace.Web, DieFace.Web],
    title: 'Entangle',
    text: 'Apply 3 Snared.',
    tags: ['debuff'],
    audio: SoundType.AttackWeb,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(target, StatusEffect.Snared, 3);
    },
  },
  {
    ingredients: [DieFace.Web, DieFace.Web, DieFace.Web],
    title: 'Constrict', //strangled
    text: 'Apply 5 Snared.',
    tags: ['debuff'],
    audio: SoundType.AttackWeb,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(target, StatusEffect.Snared, 5);
    },
  },
  {
    ingredients: [DieFace.Web, DieFace.Poison],
    title: 'Venomous Web',
    text: 'Apply 2 Snared and 2 Poisoned.',
    tags: ['debuff'],
    audio: SoundType.AttackWeb,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(target, StatusEffect.Snared, 2);
      addModifier(target, StatusEffect.Poison, 2);
    },
  },
  {
    ingredients: [DieFace.Web, DieFace.Fist],
    title: 'Throw Net',
    text: 'If the target has no Snared, add 3 Snared. Otherwise, add 2 Vulnerable.',
    tags: ['debuff'],
    audio: SoundType.AttackWeb,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      const snared = target.statusEffects.find((modifier) => {
        return modifier.type == StatusEffect.Snared;
      });
      if (snared) {
        addModifier(target, StatusEffect.Vulnerable, 2);
      } else {
        addModifier(target, StatusEffect.Snared, 3);
      }
    },
  } /* {
    ingredients: [DieFace.Web, DieFace.Agility],
    title: 'Sticky Web',
    text: 'Add 2 Snared and 1 Slowed.',
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(source, StatusEffect.Snared, 2);
      addModifier(source, 'slowed', 1);
    }
  }, */,
  //@ts-ignore
];
